const LoginPage = () => {

    return (
        <>
            <h1 className="text-center">Вхід на сайт</h1>

        </>
    )
}

export default LoginPage;

